import PopupDetails from './PopupDetails';

export default PopupDetails;
